import React from "react";
import { useLanguage } from "../Router/LanguageContext";
import { RoutesPaths } from "../Router/Constant";
import { useNavigate } from "react-router-dom";

export default function Notfound() {
  const navigate = useNavigate();
  const { dictionary } = useLanguage();

  const redirectHome = () => {
    navigate(RoutesPaths.LANDING);
  };

  return (
    <div className="container-fluid maxContainerSection commonPadding commonHeaderPadding">
      <div className="row">
        <div className="col-md-6">
          <div className="notFoundLeftSection">
            <h2 className="m-0 f-s-48 boldtext">{dictionary?.oops}</h2>
            <h2 className="m-0 f-s-48">{dictionary?.pageNotFound}</h2>
            <p className="m-0 f-s-20">{dictionary?.pageNotFoundDesc}</p>
            <button className="radius-btn" onClick={redirectHome}>
              <span className="btn-text">{dictionary?.goHome}</span>
            </button>
          </div>
        </div>
        <div className="col-md-6">
          <div>
            <img src="/assets/img/404Image.svg" alt="" className="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  );
}
